import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button } from "../../components/Button";
import { Input, Select, SelectRc } from "../../components/Input";
import ReactLoading from "react-loading";
import "./styles.less";
import { formInfo } from "../../utils/formInfo";

export const PartnerForm = (props) => {
  const { visible, setVisible } = props;
  const { handleSubmit, register, errors, reset, getValues } = useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [showNotice, setShowNotice] = useState(false);
  const [industryValue, setIndustryValue] = useState();
  const [sceneValue, setSceneValue] = useState();
  const [industryError, setIndustryError] = useState(false);
  const [sceneError, setSceneError] = useState(false);

  const industryOption = [
    t("common.formPage.finance"),
    t("common.formPage.energy"),
    t("common.formPage.car"),
    t("common.formPage.manufacture"),
    t("common.formPage.food"),
    t("common.formPage.retail"),
    t("common.formPage.server"),
    t("common.formPage.meta"),
    t("common.formPage.game"),
    t("common.formPage.consult"),
    t("common.formPage.estate"),
    t("common.formPage.media"),
    t("common.formPage.educate"),
    t("common.formPage.medical"),
    t("common.formPage.other"),
  ];
  const sceneOption = [
    { value: "b2b", label: t("common.formPage.b2b") },
    { value: "b2c", label: t("common.formPage.b2c") },
    { value: "b2e", label: t("common.formPage.b2e") },
    { value: "其他", label: t("common.formPage.other") },
  ];
  const onSubmit = async (values) => {
    // if (!industryValue || !sceneValue) {
    //   if (!industryValue) {
    //     setIndustryError(true);
    //   }
    //   if (!sceneValue) {
    //     setSceneError(true);
    //   }

    //   return;
    // }
    Object.assign(values, { industry: industryValue }, { scene: sceneValue });
    console.log(values, "values");
    setLoading(true);
    setShowNotice(true);
    try {
      await formInfo(values);

      // if (res.code === 200) {
      // setVisible(false);

      setLoading(false);
      setShowNotice(true);
      reset();
      // }
    } finally {
      // setVisible(false);
      setLoading(false);
      setShowNotice(true);
    }
  };

  const onError = (errors, e) => {
    console.log(errors);
  };

  const notice = () => {
    return (
      <div className="notice-block">
        <div className="notice-title">{t("common.form.success-tip")}</div>

        <div className="notice-img">
          <img
            src="//files.authing.co/authing-website/consult-form-img.png"
            alt="authing"
          />
        </div>
      </div>
    );
  };

  const form = () => {
    return (
      <div className="authing-form-block">
        <div className="form-warp">
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <div className="form-item">
              <div className="input">
                <Input
                  error={errors.name}
                  placeholder={t("common.formPage.name")}
                  name="name"
                  inputRef={register({
                    required: true,
                    pattern: {
                      value: /^[^\s]*$/,
                      message: "error message",
                    },
                  })}
                />
              </div>
            </div>
            <div className="form-item">
              <div className="input">
                <Input
                  name="company"
                  error={errors.company}
                  placeholder={t("common.formPage.company")}
                  inputRef={register({
                    required: true,
                    pattern: {
                      value: /^[^\s]*$/,
                      message: "error message",
                    },
                  })}
                />
              </div>
            </div>
            <div className="form-item">
              <div className="select">
                <SelectRc
                  error={industryError}
                  setError={setIndustryError}
                  placeholder={t("common.formPage.industry")}
                  name="industry"
                  options={industryOption}
                  currentValue={industryValue}
                  setCurrentValue={setIndustryValue}
                  selectRul={{ value: /^[^\s]*$/, message: "error message" }}
                />
              </div>
            </div>
            <div className="form-item">
              <div className="input">
                <Input
                  name="position"
                  error={errors.position}
                  placeholder={t("common.formPage.position")}
                  inputRef={register({
                    required: true,
                    pattern: {
                      value: /^[^\s]*$/,
                      message: "error message",
                    },
                  })}
                />
              </div>
            </div>

            <div className="form-item">
              <div className="input">
                <Input
                  name="phone"
                  error={errors.phone}
                  placeholder={t("common.formPage.phone")}
                  inputRef={register({
                    required: true,
                    pattern: {
                      value: /^1[3-9]\d{9}$/,
                      message: "error message",
                    },
                  })}
                />
              </div>
            </div>
            <div className="form-item">
              <div className="select">
                <SelectRc
                  error={sceneError}
                  setError={setSceneError}
                  placeholder={t("common.formPage.scene")}
                  name="scene"
                  mode="tags"
                  options={sceneOption}
                  currentValue={sceneValue}
                  setCurrentValue={setSceneValue}
                  selectRul={{ value: /^[^\s]*$/, message: "error message" }}
                />
              </div>
            </div>
            <div className="form-item">
              <Button
                type="submit"
                className="consult-submit"
                disabled={loading}
              >
                {loading ? (
                  <ReactLoading
                    type={"spin"}
                    height={20}
                    width={20}
                    delay={0}
                    className={"spin-loading"}
                  />
                ) : (
                  ""
                )}
                {t("common.form.submit")}
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  };
  return <div>{showNotice ? notice() : form()}</div>;
};

export const FormContent = () => {
  const { t } = useTranslation();
  return (
    <div className="form-content">
      <div className="form-title">
        <div className="form-subtitle">{t("common.formPage.subtitle")}</div>
        <div>{t("common.formPage.title")}</div>
      </div>
      <div className="form-text">
        <div className="img-left">
          <img
            src="//files.authing.co/authing-website/brand-left-02.png"
            alt="authing"
          ></img>
        </div>
        <PartnerForm />
        <div className="img-right">
          <img
            src="//files.authing.co/authing-website/brand-right-03.png"
            alt="authing"
          ></img>
        </div>
      </div>
    </div>
  );
};
